import { IVillageForListPresenterSchema } from '../../../node/repositories/countryside-search/entities/village/VillageForListPresenterSchema';
import { ISopr1Product, EDealType, EObjectType } from '../../types/analytics';

export const gatherAnalyticsInfo = (
  { builder, id, name, thumbnailList }: IVillageForListPresenterSchema,
  index: number = 0,
): ISopr1Product => ({
  id,
  dealType: EDealType.other,
  objectType: EObjectType.kp,
  name: `Коттеджный посёлок «${name}»`,
  position: index + 1,
  brand: `${builder.id}/developer`,
  photosCount: thumbnailList.length,
});
